import { useLenis } from "../hooks/useLenis";
import { ScrollProgressBar } from "../components/motion/ScrollProgressBar";
import { Navigation } from "../components/landing/Navigation";
import { Hero } from "../components/landing/Hero";
import { ProblemAgitation } from "../components/landing/ProblemAgitation";
import { AcademyIntro } from "../components/landing/AcademyIntro";
import { CoachBio } from "../components/landing/CoachBio";
import { ResourcesGrid } from "../components/landing/ResourcesGrid";
import { ConsultationHighlight } from "../components/landing/ConsultationHighlight";
import { FutureReleases } from "../components/landing/FutureReleases";
import { WhoThisIsFor } from "../components/landing/WhoThisIsFor";
import { Testimonials } from "../components/landing/Testimonials";
import { Guarantee } from "../components/landing/Guarantee";
import { Pricing } from "../components/landing/Pricing";
import { FAQSection } from "../components/landing/FAQSection";
import { Footer } from "../components/landing/Footer";
import { StickyMobileCTA } from "../components/landing/StickyMobileCTA";
import { ExitIntentModal } from "../components/landing/ExitIntentModal";
import { SocialProofToast } from "../components/landing/SocialProofToast";

export default function LandingPage() {
  useLenis();
  return (
    <div className="bg-[#08080A] text-white min-h-screen selection:bg-rose-600 selection:text-white">
      <ScrollProgressBar />
      <Navigation />
      <main>
        <Hero />
        <ProblemAgitation />
        <AcademyIntro />
        <CoachBio />
        <ResourcesGrid />
        <ConsultationHighlight />
        <FutureReleases />
        <WhoThisIsFor />
        <Testimonials />
        <Guarantee />
        <Pricing />
        <FAQSection />
      </main>
      <Footer />
      <StickyMobileCTA />
      <ExitIntentModal />
      <SocialProofToast />
    </div>
  );
}
